const buttonSharedStyles = () => ({
  '.btn': {
    boxSizing: 'border-box',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out, visibility 0',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: "'CentraNo1', 'Roboto', sans-serif",
    outline: 'none',
    background: 'transparent',
    border: 'none',
    padding: '0',

    '&.disabled': {
      cursor: 'not-allowed',
    },
  },

  '.btn-classic': {
    borderRadius: '9999px;',
  },

  '.btn-classic-small': {
    height: '36px',
    padding: '0 20px',
  },

  '.btn-classic-large': {
    height: '46px',
    padding: '0 26px',
  },

  '.btn-circle': {
    justifyContent: 'center',
    borderRadius: '9999px',
    padding: '0px',
  },

  '.btn-circle-small': {
    height: '36px',
    width: '36px',
  },

  '.btn-circle-large': {
    height: '48px',
    width: '48px',
  },
});

module.exports = { buttonSharedStyles };
